module.exports = __webpack_public_path__ + "img/thumbnail_ScimitarHornedOryx_j_normal.7456ad2b.png";